import {
  getCheckinInfo,
  confirmCheckin,
  getPublicPackages,
  requestSubscription,
} from '@/services/CheckinService.js';

export default {
  async fetchCheckinInfo(context, schoolId) {
    context.commit('setLoading', true);
    try {
      const data = await getCheckinInfo(schoolId);
      context.commit('setCheckinInfo', data.data);
      return data.data;
    } finally {
      context.commit('setLoading', false);
    }
  },

  async confirmCheckin(context, { schoolId, scheduleIds }) {
    context.commit('setLoading', true);
    try {
      const data = await confirmCheckin(schoolId, scheduleIds);
      return data.data.results;
    } finally {
      context.commit('setLoading', false);
    }
  },

  async fetchPublicPackages(context, schoolId) {
    const data = await getPublicPackages(schoolId);
    context.commit('setPublicPackages', data.data.packages);
    return data.data.packages;
  },

  async requestSubscription(context, { schoolId, data }) {
    context.commit('setLoading', true);
    try {
      const result = await requestSubscription(schoolId, data);
      return result.data.subscription;
    } finally {
      context.commit('setLoading', false);
    }
  },
};
